module.exports = __webpack_public_path__ + "static/img/manual_zh_25.f422bdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_25.png
// module id = Dk6O
// module chunks = 4